import { XIcon } from 'lucide-react'

import { cn } from '@/lib/utils'

export interface EmailChipProps {
  values: string[]
  onClickChip: (value: string) => void
}

export const EmailChips = ({ values, onClickChip }: EmailChipProps) => {
  return (
    <div className={cn('flex flex-wrap')}>
      {values.map((value, index) => (
        <div
          key={`${value}-${index}`}
          className={cn('flex items-center', 'px-2 py-1', 'rounded-[6px] bg-blue-50', 'mb-2 mr-2', 'text-blue-600')}
        >
          <span className={cn('text-[12px] font-medium leading-[20px]')}>{value}</span>
          <button className={cn('ml-2')} onClick={() => onClickChip(value)}>
            <XIcon size={16} />
          </button>
        </div>
      ))}
    </div>
  )
}
